import React, { useEffect } from 'react'
import { MuiGrid, MuiTypography, MuiTableCell, MuiTableHead, MuiTableRow } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme';
import { makeStyles, withStyles } from '@material-ui/core/styles';

const TableCell = withStyles({
    root: {
        border: "none",
        cursor: "default",
    }
})(MuiTableCell);

const TableRow = withStyles({
    root: {
        cursor: "default",
    }
})(MuiTableRow);

const TableHead = withStyles({
    root: {
        cursor: "default",
    }
})(MuiTableHead);

const useStyles = makeStyles(theme => ({
    dummyCell: { height: 'auto', width: '3%' },
    headerGrid: { height: 'auto', width: '97%' },
    dayGridStyle: { height: 'auto', borderRight: '3px solid ' + theme.palette.grey.dark, border: '1px solid ' + theme.palette.grey.dark, background: theme.palette.grey.lighter },
    lastDayGridStyle: { height: 'auto', border: '1px solid ' + theme.palette.grey.dark, background: theme.palette.grey.lighter },
    dayTextStyle: { color: theme.palette.grey.darker, fontWeight: 600 },
    cellGrid: { width: '100%', height: '5vh' },

    cellText: { wordBreak: 'break-word'},
    emptyGrid: { border: '1px solid ' + theme.palette.grey.main, background: theme.palette.grey.lighter },
}));


export default function MasterScheduleHeader(props) {
    const i18n = props.i18n
    let header = props.header
    const classes = useStyles();
    const [arrPeriodList, setArrPeriodList] = React.useState([]);
    const [arrHeaderList, setArrHeaderList] = React.useState([]);

    const days = [{ code: 'su', "name": i18n.days.SUNDAY, index: 0 },
    { code: 'mo', "name": i18n.days.MONDAY, index: 1 },
    { code: 'tu', "name": i18n.days.TUESDAY, index: 2 },
    { code: 'we', "name": i18n.days.WEDNESDAY, index: 3 },
    { code: 'th', "name": i18n.days.THURSDAY, index: 4 },
    { code: 'fr', "name": i18n.days.FRIDAY, index: 5 },
    { code: 'sa', "name": i18n.days.SATURDAY, index: 6 }]
    const getDay = (day1) => {
        let day = days.find((d) => d.index == day1.dayNumber)
        return day.name

    }

    function setData() {
        const i18n = props.i18n

        let arrPeriodList = [];

        let arrHeaderList = [];

        for (let i = 0; i < header.length; i++) {
            let cell = <TableCell align='center' className={header.length - 1 != i ? classes.dayGridStyle : classes.lastDayGridStyle}
                colspan={header[i].periods.length}>

                <MuiTypography variant={theme.typographyStyles.BODY2} className={classes.dayTextStyle}
                > {getDay(header[i])}</MuiTypography>

            </TableCell>
            arrHeaderList.push(cell)
            for (let j = 0; j < header[i].periods.length; j++) {


                let lastPeriod = (header[i].periods.length - 1 == j && header.length - 1 != i)


                let cell = <TableCell style={props.getCellStyle(header[i].periods[j].typeOfPeriod, header[i], 'header', "white", false, lastPeriod)}>

                    {header[i].periods[j].typeOfPeriod != 'lunch' && header[i].periods[j].typeOfPeriod != 'break' ?
                        <MuiGrid className={classes.cellText} align='center'>
                            <MuiGrid><MuiTypography variant={theme.typographyStyles.CAPTION} style={{ fontSize: '10px' }}>
                                {props.renderTime(header[i].periods[j].startTime_str)}</MuiTypography></MuiGrid>
                            <MuiGrid><MuiTypography variant={theme.typographyStyles.CAPTION} style={{ fontSize: '10px' }}>
                                {props.renderTime(header[i].periods[j].endTime_str)}</MuiTypography></MuiGrid></MuiGrid>
                        :


                        <MuiTypography
                            style={{
                                visibility: header[i].periods[j].typeOfPeriod != 'lunch' && 'hidden',
                                fontSize: 10, writingMode: 'vertical-lr'
                            }}>
                            {i18n.weeklyTimeTable.masterScheduleBreakLabel}
                        </MuiTypography>

                    }
                </TableCell >
                arrPeriodList.push(cell)
            }
        }
        setArrPeriodList(arrPeriodList)
        setArrHeaderList(arrHeaderList)
    }
    useEffect(() => {
        setData();
    }, []);
    return (
        <TableHead >
            <TableRow>
                <TableCell style={{ background: 'white',position:'sticky',zIndex:100 }}></TableCell>
                {arrHeaderList}
            </TableRow>
            <TableRow>
                <TableCell style={{ background: 'white',top:22,position:'sticky',zIndex:100 }}></TableCell>
                {arrPeriodList}
            </TableRow>

        </TableHead>


    )

}